'use client';

import { isSvgContent, SVG_MIME_TYPE, SVG_SNIFF_BYTES } from '@/collections/_validations/upload-rules';
import { fileTypeFromBlob } from 'file-type';

/**
 * What the bytes of a picked file really are, before we ask the server to sign anything.
 *
 * The browser fills `File.type` from the extension, so a WebM named `.png` arrives as `image/png`.
 * The server corrects that from the buffer in `resolveMimeType`, but a browser upload is signed
 * before any byte reaches us: the signature would carry the image formats, and Cloudinary would
 * refuse the real bytes. This is the browser half of that rule, and `isSvgContent` is the shared
 * half of the decision.
 *
 * A file nothing recognises keeps its declared type, which `declaredUploadViolation` then refuses.
 */
export const resolveFileMimeType = async (file: File): Promise<string> => {
  const detected = (await fileTypeFromBlob(file))?.mime;
  const head = await file.slice(0, SVG_SNIFF_BYTES).text();

  return isSvgContent(detected, head) ? SVG_MIME_TYPE : (detected ?? file.type);
};
